vex.defaultOptions.className = 'vex-theme-default';
